module.exports = __webpack_public_path__ + "img/customer-service.39042e6.png";